import { characters } from "@davi-ai/retorik-framework";
import { RetorikConfiguration } from "../Components/Bot/data";

const changeGender: Function = (
  gender: string,
  config: RetorikConfiguration,
) => {
  let changedConfig: RetorikConfiguration = { ...config };
  let mainContainer = document.getElementById("retorik-container");

  if (gender === "base") {
    //changedConfig.agentData = characters.lea;
    changedConfig.chatbotData.size = undefined;
    if (mainContainer) {
      mainContainer.classList.remove("patienteDisplay");
    }
  } else if (gender === "male") {
    //changedConfig.agentData = characters.jeanmarc;
    changedConfig.chatbotData.size = undefined;
    if (mainContainer) {
      mainContainer.classList.remove("patienteDisplay");
    }
  } else if (gender === "female") {
    //changedConfig.agentData = characters.alice;
    changedConfig.chatbotData.size = undefined;
    if (mainContainer) {
      mainContainer.classList.add("patienteDisplay");
    }
  }
  return changedConfig;
};

const changeVoice: Function = (
  gender: any | undefined,
  voice: string | undefined,
  config: RetorikConfiguration,
) => {
  let changedConfig: RetorikConfiguration = { ...config };
  if (voice) {
    changedConfig.customVoice = {
      voice: voice,
    };
  } else if (gender) {
    changedConfig.customVoice = {
      gender: gender,
    };
  }

  return changedConfig;
};

export { changeGender, changeVoice };
